document.documentElement.classList.remove('no-js');

(function(){
  function fmtNum(n){
    var num = Number(n);
    if(!isFinite(num)){ return '0'; }
    return (Math.round(num * 100) / 100).toString().replace(/\.0+$/,'').replace(/(\.\d*[1-9])0+$/,'$1');
  }
  function updateEstimator(box){
    var typeEl = box.querySelector('[data-est-type]');
    var type = typeEl ? typeEl.value : 'gang';
    var w = parseFloat((box.querySelector('[data-est-width]')||{}).value || '0');
    var h = parseFloat((box.querySelector('[data-est-height]')||{}).value || '0');
    var q = parseInt((box.querySelector('[data-est-qty]')||{}).value || '1', 10);
    var result = box.querySelector('[data-est-result]');
    var sheetW = parseFloat(box.getAttribute('data-sheet-width') || '13');
    var sheetH = parseFloat(box.getAttribute('data-sheet-height') || '18');
    if(!result){ return; }
    if(!w || !h || !q || w <= 0 || h <= 0 || q <= 0){
      result.textContent = 'Enter a valid print size and quantity.';
      return;
    }
    if(w > sheetW || h > sheetH){
      result.textContent = 'Max size is 13 x 18 inches. Reduce the size to fit Solo, Upload, or Gang Sheet limits.';
      return;
    }
    var gap = 0.25;
    var across = Math.max(1, Math.floor(sheetW / (w + gap)));
    var down = Math.max(1, Math.floor(sheetH / (h + gap)));
    var perSheet = Math.max(1, across * down);
    var sheets = Math.ceil(q / perSheet);
    if(type === 'solo'){
      result.textContent = 'Solo Print: ' + fmtNum(w) + ' x ' + fmtNum(h) + ' in is valid. Max size is 13 x 18. Quantity: ' + q + '. You will need ' + q + ' solo print' + (q === 1 ? '' : 's') + '.';
      return;
    }
    if(type === 'upload'){
      result.textContent = 'Upload Print: ' + fmtNum(w) + ' x ' + fmtNum(h) + ' in is valid. Max size is 13 x 18. Quantity: ' + q + '. Upload your artwork and order ' + q + ' print' + (q === 1 ? '' : 's') + '.';
      return;
    }
    result.textContent = 'Gang Sheet: Estimated ' + sheets + ' sheet' + (sheets === 1 ? '' : 's') + ' for ' + q + ' print' + (q === 1 ? '' : 's') + '. Fits about ' + perSheet + ' per 13 x 18 sheet at ' + fmtNum(w) + ' x ' + fmtNum(h) + ' in.';
  }
  document.querySelectorAll('.nsm-estimator').forEach(function(box){
    box.querySelectorAll('input, select').forEach(function(input){
      input.addEventListener('input', function(){ updateEstimator(box); });
      input.addEventListener('change', function(){ updateEstimator(box); });
    });
    updateEstimator(box);
  });
})();
